import { Row, Col } from 'antd';
import { useEffect, useState } from 'react';
import HomeBarChart from '../../components/reportes/home/HomeBarChart';
import { withAuthenticationRequired, useAuth0 } from "@auth0/auth0-react";
import { GenericAreaChart } from '../../components/reportes/GenericAreaChart';
import GenericMultichart from '../../components/reportes/GenericMultichart';
import { theme } from '../../theme';
import { StatCard, StatCardsContainer } from '../../components/common';

const Reportes = () => {  
    const {user, getAccessTokenSilently} = useAuth0();

    // Tarjetas
    const [kgFibraSemilla, setKgFibraSemilla] = useState<any[]>([]);
    const [loadingFibraSemilla, setLoadingFibraSemilla] = useState<boolean>(true);
    const [camionesIngresadosAlgodon, setCamionesIngresadosAlgodon] = useState<any[]>([]);
    const [loadingCamiones, setLoadingCamiones] = useState<boolean>(true);
    const [ultimoCiclo, setUltimoCiclo] = useState<string>("2024/25");

    // Barchart de clientes
    const [barchartData, setBarchartData] = useState<any[]>([]);

    // Areachart Camiones
    const [areachartCamionesIngresadosLabels, setAreachartCamionesLabels] = useState<any[]>([]);
    const [areachartCamionesIngresadosData, setAreachartCamionesIngresadosData] = useState<any[]>([]);
    const [areachartCamionesSalidosData, setAreachartCamionesSalidosData] = useState<any[]>([]);

    // Areachart Fibra y Semilla
    const [areachartFibraSemillaLabels, setAreachartFibraSemillaLabels] = useState<any[]>([]);
    const [areachartFibraData, setAreachartFibraData] = useState<any[]>([]);
    const [areachartSemillaData, setAreachartSemillaData] = useState<any[]>([]);

    // Barchart Ritmo Desmote
    const [barchartRitmoDesmoteData, setBarchartRitmoDesmoteData] = useState<any[]>([]);
    const [barchartRitmoDesmoteLabels, setBarchartRitmoDesmoteLabels] = useState<any[]>([]);
    const [ritmoDesmotePromedio, setRitmoDesmotePromedio] = useState<number>(0);

    const id_empresa = user?.id_empresa;
    const id_cliente = user?.id_cliente;
    const tipo_usuario = user?.tipo_usuario;

    const datosUsuarioListos = id_empresa !== undefined && id_cliente !== undefined && tipo_usuario !== undefined;
    const variables = datosUsuarioListos ? `${tipo_usuario}/${id_empresa}/${id_cliente}` : null;

    // Obtener el último ciclo
    const apiEndpointUltimoCiclo = id_empresa ? `${process.env.REACT_APP_REPORTES_URL}/ultimo_ciclo/${id_empresa}` : null;
    useEffect(() => {
        if (!apiEndpointUltimoCiclo) return;
        const fetchData = async () => {
            try {
                const token = await getAccessTokenSilently();
                const response = await fetch(apiEndpointUltimoCiclo, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });
                const data = await response.json();
                if (data && data.length > 0) {
                    setUltimoCiclo(data[0].ultimo_ciclo || "2024/25");
                }
            } catch (error) {
                console.error('Error fetching ultimo ciclo:', error);
                setUltimoCiclo("2024/25");
            }
        };
        fetchData();
    }, [apiEndpointUltimoCiclo, getAccessTokenSilently]);

    const apiEndpointCamionesIngresadosKgAlgodon = variables ? `${process.env.REACT_APP_REPORTES_URL}/home/ingresos_camiones_algodon/${variables}` : null;
    useEffect(() => {
        if (!apiEndpointCamionesIngresadosKgAlgodon) return;
        const fetchData = async () => {
            setLoadingCamiones(true);
            try {
                const token = await getAccessTokenSilently();
                const response = await fetch(apiEndpointCamionesIngresadosKgAlgodon, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });
                const data = await response.json();
                setCamionesIngresadosAlgodon(Array.isArray(data) ? data : []);
            } catch (error) {
                console.error('Error fetching data:', error);
                setCamionesIngresadosAlgodon([]);
            } finally {
                setLoadingCamiones(false);
            }
        };
        fetchData();
    }, [apiEndpointCamionesIngresadosKgAlgodon, getAccessTokenSilently]);

    const apiEndpointFibraSemilla = variables ? `${process.env.REACT_APP_REPORTES_URL}/home/kg_fibra_semilla/${variables}` : null;
    useEffect(() => {
        if (!apiEndpointFibraSemilla) return;
        const fetchData = async () => {
            setLoadingFibraSemilla(true);
            try {
                const token = await getAccessTokenSilently();
                const response = await fetch(apiEndpointFibraSemilla, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });
                const data = await response.json();
                setKgFibraSemilla(Array.isArray(data) ? data : []);
            } catch (error) {
                console.error('Error fetching data:', error);
                setKgFibraSemilla([]);
            } finally {
                setLoadingFibraSemilla(false);
            }
        };
        fetchData();
    }, [apiEndpointFibraSemilla, getAccessTokenSilently]);

    const apiEndpointBarchartKgFibra = variables ? `${process.env.REACT_APP_REPORTES_URL}/home/barchart_kg_fibra/${variables}` : null;
    useEffect(() => {
        if (!apiEndpointBarchartKgFibra) return;
        const fetchData = async () => {
            try {
                const token = await getAccessTokenSilently();
                const response = await fetch(apiEndpointBarchartKgFibra, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });
                const data = await response.json();
                setBarchartData(Array.isArray(data) ? data : []);
            } catch (error) {
                console.error('Error fetching data:', error);
                setBarchartData([]);
            }
        };
        fetchData();
    }, [apiEndpointBarchartKgFibra, getAccessTokenSilently]);

    const apiEndpointAreachartCamionesIngresados = variables ? `${process.env.REACT_APP_REPORTES_URL}/home/areachart_ultimos_camiones_ingresados_por_dia/${variables}` : null;
    useEffect(() => {
        if (!apiEndpointAreachartCamionesIngresados) return;
        const fetchData = async () => {
            try {
                const token = await getAccessTokenSilently();
                const response = await fetch(apiEndpointAreachartCamionesIngresados, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });
                const data = await response.json();
                setAreachartCamionesLabels(Array.isArray(data?.labels) ? data.labels : []);
                setAreachartCamionesIngresadosData(Array.isArray(data?.camiones_ingresados) ? data.camiones_ingresados : []);
                setAreachartCamionesSalidosData(Array.isArray(data?.camiones_salidos) ? data.camiones_salidos : []);
            } catch (error) {
                console.error('Error fetching data:', error);
                setAreachartCamionesLabels([]);
                setAreachartCamionesIngresadosData([]);
                setAreachartCamionesSalidosData([]);
            }
        };
        fetchData();
    }, [apiEndpointAreachartCamionesIngresados, getAccessTokenSilently]);

    const apiEndpointAreachartFibraSemilla = variables ? `${process.env.REACT_APP_REPORTES_URL}/home/linechart_kg_fibra_semilla_por_dia/${variables}` : null;
    useEffect(() => {
        if (!apiEndpointAreachartFibraSemilla) return;
        const fetchData = async () => {
            try {
                const token = await getAccessTokenSilently();
                const response = await fetch(apiEndpointAreachartFibraSemilla, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });
                const data = await response.json();
                setAreachartFibraSemillaLabels(Array.isArray(data?.labels) ? data.labels : []);
                setAreachartFibraData(Array.isArray(data?.kg_fibra) ? data.kg_fibra : []);
                setAreachartSemillaData(Array.isArray(data?.kg_semilla) ? data.kg_semilla : []);
            } catch (error) {
                console.error('Error fetching data:', error);
                setAreachartFibraSemillaLabels([]);
                setAreachartFibraData([]);
                setAreachartSemillaData([]);
            }
        };
        fetchData();
    }, [apiEndpointAreachartFibraSemilla, getAccessTokenSilently]);

    const apiEndpointBarchartRitmoDesmote = variables ? `${process.env.REACT_APP_REPORTES_URL}/home/barchart_ritmo_desmote/${variables}` : null;
    useEffect(() => {
        if (!apiEndpointBarchartRitmoDesmote) return;
        const fetchData = async () => {
            try {
                const token = await getAccessTokenSilently();
                const response = await fetch(apiEndpointBarchartRitmoDesmote, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });
                const data = await response.json();
                setBarchartRitmoDesmoteData(Array.isArray(data?.ritmo_desmote_kg_hora) ? data.ritmo_desmote_kg_hora : []);
                setBarchartRitmoDesmoteLabels(Array.isArray(data?.nro_produccion) ? data.nro_produccion : []);
                setRitmoDesmotePromedio(data?.ritmo_desmote_promedio || 0);
            } catch (error) {
                console.error('Error fetching data:', error);
                setBarchartRitmoDesmoteData([]);
                setBarchartRitmoDesmoteLabels([]);
                setRitmoDesmotePromedio(0);
            }
        };
        fetchData();
    }, [apiEndpointBarchartRitmoDesmote, getAccessTokenSilently]);

    // Para el promedio
    const lineChartPromedio = Array.isArray(barchartRitmoDesmoteLabels) 
        ? barchartRitmoDesmoteLabels.map(() => ritmoDesmotePromedio)
        : [];

    // Calcular valores para las tarjetas
    const camionesIngresados = camionesIngresadosAlgodon.length === 0 ? 0 : camionesIngresadosAlgodon[0].total_ingreso_camiones;
    const kgAlgodonBruto = camionesIngresadosAlgodon.length === 0 ? 0 : camionesIngresadosAlgodon[0].total_kg_algodon_bruto;
    const kgFibra = kgFibraSemilla.length === 0 ? 0 : kgFibraSemilla[0].kg_fibra;
    const kgFibrilla = kgFibraSemilla.length === 0 ? 0 : (kgFibraSemilla[0].kg_fibrilla || 0);
    const kgSemilla = kgFibraSemilla.length === 0 ? 0 : kgFibraSemilla[0].kg_semilla;
    const loadingCards = loadingCamiones || loadingFibraSemilla;

    return (
        <div style={{ padding: '0' }}>
        <h1 style={{
            color: theme.colors.primaryDark,
            fontSize: '28px',
            fontWeight: 600,
            marginBottom: '24px'
        }}>
            Información de la campaña <span style={{color: theme.colors.secondary}}>{ultimoCiclo}</span>
        </h1>
        
        <StatCardsContainer gap={16} minColumnWidth="180px">
            <StatCard
                title="Camiones Ingresados"
                value={camionesIngresados}
                color={theme.colors.primary}
                formatNumber
                loading={loadingCards}
            />
            <StatCard
                title="Kg Algodón Bruto"
                value={kgAlgodonBruto}
                color={theme.colors.primary}
                formatNumber
                loading={loadingCards}
            />
            <StatCard
                title="Kg Fibra"
                value={kgFibra}
                color={theme.colors.primary}
                formatNumber
                loading={loadingCards}
            />
            <StatCard
                title="Kg Fibrilla"
                value={kgFibrilla}
                color={theme.colors.primary}
                formatNumber
                loading={loadingCards}
            />
            <StatCard
                title="Kg Semilla"
                value={kgSemilla}
                color={theme.colors.primary}
                formatNumber
                loading={loadingCards}
            />
        </StatCardsContainer>
        <Row gutter={[16, 16]} style={{ marginTop: '24px' }}>
            <Col xs={24} lg={24}>
                <div style={{ 
                    width: '100%', 
                    height: '295px',
                    borderRadius: theme.styles.borderRadius,
                    boxShadow: theme.styles.boxShadowLight,
                    backgroundColor: '#fff'
                }}>
                    <HomeBarChart  
                        title={tipo_usuario === "D" ? 'Kg. Fibra por Cliente' : 'Kg. Fibra por Establecimiento'}
                        barChartData={barchartData}
                        xlabel={tipo_usuario === "D" ? 'Cliente' : 'Lote'}/>
                </div>
            </Col>
        </Row>
        <Row gutter={[16, 16]} style={{ marginTop: '24px' }}>
            <Col xs={24} lg={12}>
                <div style={{ 
                    width: '100%', 
                    height: '300px',
                    borderRadius: theme.styles.borderRadius,
                    boxShadow: theme.styles.boxShadowLight,
                    backgroundColor: '#fff'
                }}>
                    <GenericAreaChart
                        title={"Cantidad de Camiones Ingresados/Egresados - Últimos 15 días"}
                        dataset1_label={"Camiones Ingresados"}
                        dataset2_label={"Camiones Egresados"}
                        areachartlabels={areachartCamionesIngresadosLabels}
                        areachartdata1={areachartCamionesIngresadosData}
                        areachartdata2={areachartCamionesSalidosData}/>
                </div>
            </Col>
            <Col xs={24} lg={12}>
                <div style={{ 
                    width: '100%', 
                    height: '300px',
                    borderRadius: theme.styles.borderRadius,
                    boxShadow: theme.styles.boxShadowLight,
                    backgroundColor: '#fff'
                }}>
                    <GenericAreaChart
                        title={"Kg Fibra y Semilla - Últimos 15 días"}
                        dataset1_label={"Kg. Fibra"}
                        dataset2_label={"Kg. Semilla"}
                        areachartlabels={areachartFibraSemillaLabels}
                        areachartdata1={areachartFibraData}
                        areachartdata2={areachartSemillaData}/>
                </div>
            </Col>
        </Row>
        {tipo_usuario === "D" && barchartRitmoDesmoteData.length > 0 && (
            <Row gutter={[16, 16]} style={{ marginTop: '24px' }}>
                <Col xs={24} lg={24}>
                    <div style={{ 
                        width: '100%', 
                        height: '300px',
                        borderRadius: theme.styles.borderRadius,
                        boxShadow: theme.styles.boxShadowLight,
                        backgroundColor: '#fff'
                    }}>
                        <GenericMultichart
                            title={"Ritmo de Desmote (Kg. Fibra/Hora) - Últimas 30 producciones"}
                            labels={barchartRitmoDesmoteLabels}
                            data1={barchartRitmoDesmoteData}
                            dataset_label1={"Ritmo de Desmote"}
                            type1={"bar"}
                            data2={lineChartPromedio}
                            dataset_label2={"Ritmo de Desmote Promedio"}
                            type2={"line"}/>
                    </div>
                </Col>
            </Row>
        )}
       
        {/* <Row className='my-4'>
            <Col xs={24} md={24} lg={24}>
                <h5>Últimos camiones Ingresados</h5>
                <HomeUltimosIngresosCamionesTable id_empresa={1}/>
            </Col>
        </Row> */}
        </div>
    );
};

export default withAuthenticationRequired(Reportes);